import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import JobDetailPage from './pages/JobDetailPage';
import DomainCheckerPage from './pages/DomainCheckerPage';
import KeywordSearchPage from './pages/KeywordSearchPage';
import HistoryCheckPage from './pages/HistoryCheckPage';
import VersionBadge from './components/VersionBadge';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="animate-pulse text-zinc-400 font-body text-sm">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/jobs/:jobId" element={<ProtectedRoute><JobDetailPage /></ProtectedRoute>} />
          <Route path="/domain-checker" element={<ProtectedRoute><DomainCheckerPage /></ProtectedRoute>} />
          <Route path="/keyword-search" element={<ProtectedRoute><KeywordSearchPage /></ProtectedRoute>} />
          <Route path="/history-check" element={<ProtectedRoute><HistoryCheckPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <VersionBadge />
    </AuthProvider>
  );
}

export default App;
